<template>
  <div class="interview-wrapper bg_fff">

    <h2 class="title">{{ nowType === 'create' ? `将「${jobPost}」升级为直面职位` : `设置「${jobPost}」可安排电话沟通的时间` }}
      <div class="iconfont icontishi1">
        <p class="title-tooltip">直面职位邀约/投递的心仪候选人可直接反馈接受电话沟通的时间</p>
      </div>
    </h2>

    <div class="date-title">
      <div class="date-title-left">
        <span class="date-time">
          {{ `${moment(nowDateArr.length && nowDateArr[0].interview_date).format('YYYY.MM.DD')} - ${moment(nowDateArr.length && nowDateArr[nowDateArr.length - 1].interview_date).format('YYYY.MM.DD')}` }}
        </span>
        <div class="date-button-left date-button" @click="toggleDate('subtract')">
          <i class="iconfont iconxuanxiang-shouqi"></i>
        </div>
        <div class="date-button-right date-button" @click="toggleDate('add')">
          <i class="iconfont iconxuanxiang-shouqi"></i>
        </div>
      </div>
      <div class="date-title-right">
        <div class="date-description able">可安排电话沟通</div>
        <div class="date-description disable">不方便安排</div>
      </div>
    </div>

    <table class="date-box" v-loading="isLoading">

      <tr>
        <td></td>
        <td>
          <span>上午</span>
          <span>（9:00-12:00）</span>
        </td>
        <td>
          <span>下午</span>
          <span>（14:00-19:00）</span>
        </td>
      </tr>

      <tr v-for="(item, index) in nowDateArr || []" :key="index">

        <!-- 30天范围外 不可约，不可操作 -->
        <template v-if="item.outside">
          <td class="date-box-header outside">
            <span>{{ weekMap[index] }}</span>
            <span>{{ moment(item.interview_date).format('DD')  }}</span>
          </td>
          <td class="date-box-outside">
            <div class="line-box">
              <span class="line" v-for="item in 16" :key="item"></span>
            </div>
          </td>
          <td class="date-box-outside">
            <div class="line-box">
              <span class="line" v-for="item in 16" :key="item"></span>
            </div>
          </td>
        </template>

        <!-- 可操作范围 -->
        <template v-else>
          <td class="date-box-header">
            <span>{{ weekMap[index] }}</span>
            <span>{{ moment(item.interview_date).format('DD')  }}</span>
          </td>
          <td class="edit" :class="item.am.status === 1 ? 'date-box-able' : 'date-box-disable'" @click="changeDate(item.am)">{{ item.am.status === 1 ? '可约' : '不可约'}}</td>
          <td class="edit" :class="item.pm.status === 1 ? 'date-box-able' : 'date-box-disable'" @click="changeDate(item.pm)">{{ item.pm.status === 1 ? '可约' : '不可约'}}</td>
        </template>

      </tr>

    </table>

    <p class="description"> 可设置接下来一个月内与候选人进行电话沟通的时间</p>
    <div class="question-box">
      <h2 class="title">设置初面问题（选填）</h2>
      <div class="question-item" v-for="(item, index) in appointment_interview_questions" :key="index" :style="{marginBottom: index === 2 ? '26px' : '16px'}">
        <template>
          <span class="item-title">{{item.title}}：</span>
          <input type="text" maxlength="50" v-model.trim="appointment_interview_questions[index].question" :placeholder="item.placeholder"/>
          <span class="num-box">{{appointment_interview_questions[index].question.length}}/50</span>
        </template>
      </div>

      <p class="description">设置的初面问题将在发送【邀约】或收到【投递】时发送给候选人</p>
    </div>
    <div class="button-wrapper">
      <div class="button confirm" @click="saveData()">{{ nowType === 'create' ? '免费升级' : '保存' }}</div>
      <div class="button cancel" v-if="nowType === 'create'" @click="toJobList(origin === 'createJob')">遗憾错过</div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import actions from '@/actions/index'
import { get_tUser } from '@/utils/utils'


export default {
  name:"interview",
  data () {
    return {
      moment,
      dateList: [], // 所有数据
      nowIndex: 0, // 当前周指针
      maxIndex: null,
      nowType: null, // 可能的值 set编辑 create创建
      userJWT: null, // 用户信息
      jobToken: null, // 职位 token
      origin: null, // 可能的值 createJob：来自新创建的职位
      activeArr: [], // 存储用户修改后的数据，最后会作为参数返回给后端保存
      jobStartAt: null, // 这个职位有效期的开始时间
      jobPost: '', // 职位名
      isLoading: true, // 是否正在加载
      weekMap: ['周一', '周二','周三', '周四', '周五', '周六', '周日'],
      appointment_interview_questions: [
        {
          title: "问题一",
          id: "",
          question: "",
          job_token: "",
          placeholder: "例：请问你换工作的原因是什么？"
        },
        {
          title: "问题二",
          id: "",
          question: "",
          job_token: "",
          placeholder: "例：简单描述一下最有成就感的一个项目"
        },
        {
          title: "问题三",
          id: "",
          question: "",
          job_token: "",
          placeholder: "例：做一下简单的自我介绍"
        }
      ]
    }
  },
  created () {
    this.init()
  },
  computed: {
    // 目前显示的一周数据
    nowDateArr () {
      return this.dateList.slice(this.nowIndex * 7, (this.nowIndex + 1) * 7)
    }
  },
  methods: {
    // 初始化
    init () {
      // 获取 hr token
      this.userJWT = get_tUser()
      // 获取 职位 token
      this.jobToken = this.$route.params.jobToken || ''
      // 初始化类型
      // this.nowType = this.$route.query.type || 'create'
      // 从哪个页面跳过来的 可能来自创建职位成功后
      this.origin = this.$route.query.origin || ''
      // 初始化数据
      this.createData()
    },
    // 创建数据
    async createData () {
      // 思路：
      // 1. 生成一个 30天 的数据
      // 2. 请求接口，拿到数据进行混合
      // 3. 判断 30天 的第一天和最后一天是星期几
      // 4. 然后对应给数据补上 前面缺的几天 和 后面缺的几天，设置唯一标识，是不可用的天
      // 5. 补全后的数据就是7的倍数了，第一天就是星期一，接着7天7天的展示就行，左右切换就+7或-7

      // 获取职位开始日期 作为 起始日期
      try {
        let res = await actions.recruit_infos.get_recruit_edit(this.jobToken)
        if (res.code === 1000) {
          this.jobStartAt = res.data.job.start_at
          this.jobPost = res.data.job.job_post
          // 是直面职位 就显示编辑，不是直面职位 就显示创建
          this.nowType = res.data.job.direct_interview ? 'set' : 'create'
        }
      } catch (e) {
        console.log(e)
      }

      // 1. 生成一个 30天 的数据
      let dateArr = []
      for (let i = 0; i < 30; i++) {
        let dateValue = this.moment(this.jobStartAt).add(i, 'd').format('YYYY-MM-DD')
        let obj = {
          interview_date: dateValue,
          am: {
            interview_date: dateValue,
            interview_time: 1,
            status: 1
          },
          pm: {
            interview_date: dateValue,
            interview_time: 2,
            status: 1
          }
        }
        // 如果是周六或者周日 设置为不可约
        if (this.moment(dateValue).day() === 6 || this.moment(dateValue).day() === 0) {
          obj.am.status = 2
          obj.pm.status = 2
        }
        dateArr.push(obj)
      }
      // 2. 请求接口，拿到数据进行混合

      // 3. 判断 30天 的第一天和最后一天是星期几
      let firstIndex = this.moment(dateArr[0].interview_date).day() // firstIndex-1 是要加的天数
      let lastIndex = this.moment(dateArr[dateArr.length - 1].interview_date).day() // 7-lastIndex 是要加的天数

      // 如果拿到的是星期天0，为了便于计算，需要修改成7
      if (firstIndex === 0) {firstIndex = 7}
      if (lastIndex === 0) {lastIndex = 7}

      // 4. 然后对应给数据补上 前面缺的几天 和 后面缺的几天，设置唯一标识，是不可用的天
      // 减天数
      let firstObjArr = []
      for(let f = 1; f <= (firstIndex-1); f++) {
        let firstDateValue = this.moment(dateArr[0].interview_date).subtract(f, 'd').format('YYYY-MM-DD')
        let firstObj = {
          outside: true, // 唯一标识，这是范围之外的天数
          interview_date: firstDateValue,
          am: {
            interview_date: firstDateValue,
            interview_time: 1,
            status: 1
          },
          pm: {
            interview_date: firstDateValue,
            interview_time: 2,
            status: 1
          }
        }
        firstObjArr.unshift(firstObj)
      }
      dateArr = [...firstObjArr, ...dateArr]


      // 加天数
      let lastObjArr = []
      for(let l = 1; l <= (7-lastIndex); l++) {
        let lastDateValue = this.moment(dateArr[dateArr.length - 1].interview_date).add(l, 'd').format('YYYY-MM-DD')
        let lastObj = {
          outside: true, // 唯一标识，这是范围之外的天数
          interview_date: lastDateValue,
          am: {
            interview_date: lastDateValue,
            interview_time: 1,
            status: 1
          },
          pm: {
            interview_date: lastDateValue,
            interview_time: 2,
            status: 1
          }
        }
        lastObjArr.push(lastObj)
      }
      dateArr = [...dateArr, ...lastObjArr]

      // 5. 补全后的数据就是7的倍数了，第一天就是星期一，接着7天7天的展示就行，左右切换就+7或-7
      this.dateList = dateArr

      // 初始化周指针
      this.initIndex()
      // 请求后端数据 并 混合
      this.getData()

      // console.log('日期数据======>', this.dateList )
    },
    // 确定指针最大值
    initIndex () {
      this.maxIndex = (this.dateList.length / 7) - 1
      // 获取当天日期，计算出当天是在数据列表里的第几周，然后给 nowIndex 赋值
      let today = this.moment().format('YYYY-MM-DD')
      this.dateList.forEach((item, index) => {
        if (item.interview_date === today) {
          this.nowIndex = Math.floor(index / 7)
        }
      })
    },
    // 按周切换日期
    toggleDate (type) {
      if (type === 'add') {
        if (this.nowIndex === this.maxIndex) return
        this.nowIndex += 1
      }
      if (type === 'subtract') {
        if (this.nowIndex === 0) return
        this.nowIndex -= 1
      }
    },
    // 改变面试时间
    changeDate (itemDate) {
      // 判断目前是可约还是不可约
      // 对应改变数据的值，页面展示改变
      // 判断缓存数组里有没有相同时日的值，没有就push添加，有就替换


      // 改变对应数据的值，页面显示改变
      itemDate.status = (itemDate.status === 1 ? 2 : 1)

      // 判断缓存数组里有没有相同时日的值，没有就push添加，有就替换
      let key = true
      this.activeArr.forEach((item, index) => {
        // 有相同的就替换
        if (item.interview_date === itemDate.interview_date && item.interview_time === itemDate.interview_time) {
          key = false
          this.activeArr.splice(index, 1, JSON.parse(JSON.stringify(itemDate)))
        }
      })
      // 没有相同的就添加
      if (key) {
        this.activeArr.push( JSON.parse(JSON.stringify(itemDate)) )
      }

      // console.log('日期======>', itemDate, this.activeArr)
    },
    // 请求后端数据 并 混合
    async getData () {

      try {
        let params = {
          job_token: this.jobToken,
          hr_account_token: this.userJWT.h_t,
          start_at: this.jobStartAt
        }

        let [res,question] = await Promise.all([actions.interview.get_interview_appointment(params), actions.interview.getJobQuestion(this.jobToken)])
        if(question.code === 1000 && question.data.appointment_interview_questions.length > 0){
          this.appointment_interview_questions = question.data.appointment_interview_questions.map((item, index) => {
            return {
              ...this.appointment_interview_questions[index],
              ...item
            }
          })
        }
        if (res.code === 1000) {
          if (res.data.length) {
            // 有数据，才混合
            this.formatData(res.data)
          } else {
            // 没有数据 关闭 loading
            this.isLoading = false
          }
        }
      } catch (e) {
        console.log(e)
      }

    },
    // 混合数据
    formatData (data) {

      data.forEach((itemTarget) => {
        this.dateList.forEach((itemOrigin) => {
          if (itemTarget.interview_date === itemOrigin.interview_date && !itemOrigin.outside) {
            let { interview_time, status } = itemTarget
            if (interview_time === 1) {
              itemOrigin.am.status = status
            }
            if (interview_time === 2) {
              itemOrigin.pm.status = status
            }
          }
        })
      })

      this.isLoading = false

    },
    // 保存数据
    async saveData () {
      try {
        let params = {
          job_token: this.jobToken,
          hr_account_token: this.userJWT.h_t,
          interview:  this.activeArr
        }
        let questionApi = null
        if(this.nowType === 'set' && this.appointment_interview_questions.filter(item=>item.question).length > 0){
          if(this.appointment_interview_questions.filter(item=>item.id).length > 0){
            questionApi = actions.interview.updateJobQuestion(this.jobToken, this.appointment_interview_questions.filter(item=>item.id).map(item => ({id: item.id, question: item.question})).slice(0,3))
            if(this.appointment_interview_questions.filter(item=>!item.id).length){
              questionApi = actions.interview.createJobQuestion(this.jobToken, this.appointment_interview_questions.filter(item=>!item.id).map(item=>item.question))
            }
          }else {
            questionApi = actions.interview.createJobQuestion(this.jobToken, this.appointment_interview_questions.map(item=>item.question))
          }
        }else if(this.nowType === 'create' && this.appointment_interview_questions.filter(item=>item.question).length > 0) {
          questionApi = actions.interview.createJobQuestion(this.jobToken, this.appointment_interview_questions.map(item=>item.question))
        }
        let [res, question] = await Promise.all([actions.interview.set_interview_appointment(params), questionApi])
        // console.log(question)
        if (res.code === 1000) {
          this.$message({
            message: '设置成功',
            type: 'success'
          })
          this.toJobList(this.origin === 'createJob')
        }

      } catch (e) {
        console.log(e)
      }
    },
    // 跳转到职位列表页
    toJobList (showDialog) {
      this.$router.push({
        name: 'talentJobList',
        query: showDialog ? {token: this.jobToken} : ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./Index.scss";
</style>
